<div class="row" cdkDropListGroup>
        <div class="col-md-6">
            <div class="settlement-box p-3">
                <p class="settlement-box_title">Available settlement descriptions</p>
                <span class="settlement-box_subtitle">There are all the settlement descriptions you can add into a group
                    by drag & drop</span>
                <div class="settlement-box_search-bar">
                    <mat-checkbox *ngIf="settlements.length > 0" class="mat-checkbox-sm ms-2" [(ngModel)]="master_checked" (change)="setSelectAll($event)"
                     [disabled]="((addToSettlements$  | async)?.length==0)">Select All
                    </mat-checkbox>
                    <div class="search">
                        <div class="search-icon">
                            <i class="fal fa-search" (click)="clearSearch(false)" [ngClass]="{
                                'fa-search': !searchInput.value,
                                'fa-times': searchInput.value
                              }"></i>
                        </div>
                        <input type="text" class="input" placeholder="Search" [formControl]="searchInput" />
                    </div>
                </div>

                <div class="settlement-box_list thin-scrollbars" id="sku-list" cdkDropList infiniteScroll [scrollWindow]="false" (scrolled)="getSettlementsItems(false)">
                    <div>
                        <div class="settlement-box_list--item" *ngFor="let item of settlements"
                            (cdkDragStarted)="skuDrag($event)" cdkDrag [cdkDragData]="item" (cdkDragEnded)="cdkDragEnded($event)">
                            <mat-checkbox class="mat-checkbox-sm" (change)="selectSettlement($event, item)" [(ngModel)]="item.checked">
                            </mat-checkbox>
                            <span>
                                <svg width="7.671" height="11.414"><use xlink:href="assets/images/sprite-icons.svg#drag_icon"></use></svg>
                            </span>
                            {{item.amountType}}
                            <div class="settlement-box_drag" *cdkDragPreview>
                                <div class="settlement-box_list--item settlement-box_list--drag">
                                    <span>
                                        <svg width="7.671" height="11.414"><use xlink:href="assets/images/sprite-icons.svg#drag_icon"></use></svg>
                                    </span>
                                    {{selectedSettlements?.length == this.settlements.length ? 'All available
                                    settlement' :
                                    selectedSettlements.length ? 'All selected settlement' : item.amountType}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-loader"
                        *ngIf="((addToSettlements$  | async)?.length==0) || (settlements.length==0) || loading">
                        <app-no-results [message]="loading ? 'Loading Settlements' : 'No settlement found'"></app-no-results>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-md-6">
            <div class="settlement-box p-3">
                <p class="settlement-box_title d-flex">Groups <a class="ms-auto" (click)="createGroup($event)">Create
                        Group</a></p>
                <span class="settlement-box_subtitle">There are all the groups you can add settlement description into
                    the <br>group</span>
                <div class="settlement-box_search-bar">
                    <div class="search w-100 mw-100">
                        <div class="search-icon">
                            <i class="fal fa-search" (click)="clearSearch(true)" [ngClass]="{
                                    'fa-search': !searchGroup.value,
                                    'fa-times': searchGroup.value
                            }"></i>
                        </div>
                        <input type="text" class="input" placeholder="Search" [formControl]="searchGroup" />
                    </div>
                </div>
                <ul class="settlement-box_list thin-scrollbars" infiniteScroll [scrollWindow]="false" (scrolled)="getGroups(false)">
                        <li class="settlement-box_list--item settlement-box_list--dropped"
                            *ngFor="let settlement of settlementsGroups" cdkDragData="item">
                            <mat-accordion class="w-100" [displayMode]="'flat'" [multi]="true">
                                <mat-expansion-panel hideToggle #panel>
                                    <mat-expansion-panel-header cdkDropList  
                                    (cdkDropListDropped)="drop($event,settlement)" (mouseenter)="entered($event)"  (mouseleave)="exited($event)">
                                        {{ settlement.name | titlecase }}
                                        <span class="edit-icon ms-1" *ngIf="!settlementsDragging"><i class="far fa-edit"
                                                (click)="createGroup($event,settlement)"></i></span>

                                        <div class="action ms-auto">
                                            <span class="item-chip">{{settlement.settlementGroupItems.length || 0 }} item</span>
                                            <i class="fal fa-trash-alt text-red"
                                                (click)="deleteGroup($event,settlement)"></i>
                                            <i class="fal expand-icon" [ngClass]="{
                                        'fa-chevron-down': panel.expanded,
                                        'fa-chevron-right': !panel.expanded
                                      }"></i>
                                        </div>
                                    </mat-expansion-panel-header>
                                    <ul class="settlement_box-childlist" *ngIf="settlement.settlementGroupItems.length">
                                        <li *ngFor="let settlementGroupItems of settlement.settlementGroupItems"
                                            class="settlement_box-childlist--item">
                                            {{ settlementGroupItems.name | titlecase }}
                                            <div class="action-delete ms-auto">
                                                <i class="fal fa-trash-alt text-red"
                                                    (click)="deleteGroupItem($event,settlementGroupItems)"></i>
                                            </div>
                                        </li>
                                    </ul>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </li>
                </ul>
            </div>
        </div>
</div>